/**
 * Trunnion AI - Application Constants
 */

import type { ClassificationLevel } from '@/types';

export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api/v1';

export const WS_URL =
  import.meta.env.VITE_WS_URL || `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}`;

export const APP_NAME = 'Trunnion AI';
export const APP_DESCRIPTION = 'DAF Agentic Workflow Platform';

export const DEFAULT_PAGE_SIZE = 25;
export const MAX_PAGE_SIZE = 100;

export const TOKEN_STORAGE_KEY = 'trunnion_auth_token';
export const REFRESH_TOKEN_STORAGE_KEY = 'trunnion_refresh_token';

export const CLASSIFICATION_LEVELS: ClassificationLevel[] = [
  'UNCLASSIFIED',
  'CUI',
  'SECRET',
  'TOP_SECRET',
  'TS_SCI',
];

export const CLASSIFICATION_CONFIG: Record<
  ClassificationLevel,
  {
    label: string;
    shortLabel: string;
    color: string;
    bgColor: string;
    borderColor: string;
    textColor: string;
    bannerText: string;
    rank: number;
  }
> = {
  UNCLASSIFIED: {
    label: 'Unclassified',
    shortLabel: 'U',
    color: '#4ADE80',
    bgColor: 'bg-classification-unclassified/10',
    borderColor: 'border-classification-unclassified',
    textColor: 'text-classification-unclassified',
    bannerText: 'UNCLASSIFIED',
    rank: 0,
  },
  CUI: {
    label: 'Controlled Unclassified Information',
    shortLabel: 'CUI',
    color: '#FACC15',
    bgColor: 'bg-classification-cui/10',
    borderColor: 'border-classification-cui',
    textColor: 'text-classification-cui',
    bannerText: 'CUI - CONTROLLED UNCLASSIFIED INFORMATION',
    rank: 1,
  },
  SECRET: {
    label: 'Secret',
    shortLabel: 'S',
    color: '#F87171',
    bgColor: 'bg-classification-secret/10',
    borderColor: 'border-classification-secret',
    textColor: 'text-classification-secret',
    bannerText: 'SECRET',
    rank: 2,
  },
  TOP_SECRET: {
    label: 'Top Secret',
    shortLabel: 'TS',
    color: '#F97316',
    bgColor: 'bg-classification-top-secret/10',
    borderColor: 'border-classification-top-secret',
    textColor: 'text-classification-top-secret',
    bannerText: 'TOP SECRET',
    rank: 3,
  },
  TS_SCI: {
    label: 'Top Secret / SCI',
    shortLabel: 'TS/SCI',
    color: '#C084FC',
    bgColor: 'bg-classification-ts-sci/10',
    borderColor: 'border-classification-ts-sci',
    textColor: 'text-classification-ts-sci',
    bannerText: 'TOP SECRET // SCI',
    rank: 4,
  },
};

export const EXECUTION_STATUS_CONFIG: Record<
  string,
  { label: string; color: string; bgColor: string; textColor: string }
> = {
  pending: {
    label: 'Pending',
    color: '#F59E0B',
    bgColor: 'bg-status-pending/10',
    textColor: 'text-status-pending',
  },
  running: {
    label: 'Running',
    color: '#3B82F6',
    bgColor: 'bg-status-running/10',
    textColor: 'text-status-running',
  },
  completed: {
    label: 'Completed',
    color: '#22C55E',
    bgColor: 'bg-status-success/10',
    textColor: 'text-status-success',
  },
  failed: {
    label: 'Failed',
    color: '#EF4444',
    bgColor: 'bg-status-failed/10',
    textColor: 'text-status-failed',
  },
  cancelled: {
    label: 'Cancelled',
    color: '#6B7280',
    bgColor: 'bg-status-cancelled/10',
    textColor: 'text-status-cancelled',
  },
  waiting_approval: {
    label: 'Awaiting Approval',
    color: '#A855F7',
    bgColor: 'bg-status-waiting-approval/10',
    textColor: 'text-status-waiting-approval',
  },
  paused: {
    label: 'Paused',
    color: '#F59E0B',
    bgColor: 'bg-status-pending/10',
    textColor: 'text-status-pending',
  },
  timed_out: {
    label: 'Timed Out',
    color: '#EF4444',
    bgColor: 'bg-status-failed/10',
    textColor: 'text-status-failed',
  },
};
